import React from 'react';
import { QuestionHeading, QuestionPreviewField } from './QuestionBlockShared';

function FileUploadBlock({ block, position }) {
    const accepted = Array.isArray(block.acceptedFileTypes) ? block.acceptedFileTypes : [];

    return (
        <div className="ecx-survey-q">
            <QuestionHeading block={block} position={position} />
            <QuestionPreviewField>
                <div className="ecx-survey-q__upload">
                    <i className="bi bi-cloud-arrow-up" />
                    <div className="ecx-survey-q__upload-title">Drag and drop files here</div>
                    <div className="ecx-survey-q__hint">
                        Max {block.maxFileSize || 5} MB
                        {block.allowMultiple ? ' · Multiple files allowed' : ''}
                    </div>
                    {accepted.length ? (
                        <div className="ecx-survey-q__chips">
                            {accepted.map((type) => (
                                <span key={type} className="ecx-page-chip">
                                    {type}
                                </span>
                            ))}
                        </div>
                    ) : null}
                    <button type="button" className="btn btn-sm btn-outline-secondary rounded-pill" disabled>
                        Browse files
                    </button>
                </div>
            </QuestionPreviewField>
        </div>
    );
}

export default FileUploadBlock;
